import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from '../../../../app.config';
import { Statuses } from '../../../../enums/statuses.enum';
import { DashboardService } from '../../../../services/dashboard.service';
import { PartnerService } from '../../../../services/partner.service';
import { HelpersService } from '../../../../services/helpers.service';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { ChecklistService } from '../../../../services/checklist.service';
import { InvoiceService } from '../../../../services/invoice.service';
import { BikeService } from '../../../../services/bike.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateJobcardComponent } from '../../../modals/update-jobcard/update-jobcard.component';
import { MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { SelectTechnicianModalComponent } from '../../../modals/select-technician-modal/select-technician-modal.component';
import * as json2csv from 'json2csv'; // convert json file to csv
import { saveAs } from 'file-saver'; // save the file
import moment from 'moment';
import { ConfirmationService } from 'primeng/api';
import { CancellationReasons } from '../../../../enums/cancellation-reasons.enum';
import { CollectionsV2Service } from '../../../../services/collectionsV2.service';
import { ScheduleServiceComponent } from 'src/app/components/modals/schedule-service/schedule-service.component';
import { NewJobcardService } from '../../../../services/new-jobcard.service';
import { WorkshopJobcardSearchSerialNumberComponent } from '../../../modals/workshop-jobcard/workshop-jobcard-search-serial-number/workshop-jobcard-search-serial-number.component';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
  providers: [MessageService],
})
export class ServicesComponent implements OnInit {
  public loading: boolean = true;
  public partnerID: string = '';
  public partner: any = {};
  public dashboardInfo: any = [];
  public statusList: any = [];
  public activeItem: any = {};
  public jobCards: any = [];
  public technicians: any = [];
  public columns: any = [];
  public openColumns: any = [];
  public routeData: any = '';
  public filters: any = [0];
  public selectedFilter: number = 0;
  public Json2csvParser = json2csv.Parser;
  public countryData: any = {};
  public displayDateFormat: any = 'dd-MM-yyyy';
  public displayDateTimeFormat: any = 'dd-MM-yyyy HH:mm';
  public busyBulkActioning: boolean = false;
  public globalSelectValue: boolean = false;
  public displayCancellation: boolean = false;
  public cancellationreasons: any = [];
  public selectedCancellationReason: any = [];
  public showCancellationOtherReason: boolean = false;
  public cancellationOtherReason: string = '';

  public loadingPartners = false;
  public linkedPartners: any = [];
  public selectedPartners: any = [];
  public selectedPartnerIds: any = [];
  public isAdmin = false;
  public isWorkshopManager = false;

  constructor(
    public dashboardService: DashboardService,
    public partnerService: PartnerService,
    public helpersService: HelpersService,
    public appConfig: AppConfig,
    public route: ActivatedRoute,
    public router: Router,
    public serviceRequest: ServiceRequestService,
    public bikeService: BikeService,
    public invoiceService: InvoiceService,
    public messageService: MessageService,
    public modalService: NgbModal,
    private translate: TranslateService,
    private checklistService: ChecklistService,
    private confirmationService: ConfirmationService,
    public collectionsV2Service: CollectionsV2Service,
    private newJobcardService: NewJobcardService
  ) { }

  ngOnInit() {
    this.partnerID = this.helpersService.getPartnerId();
    this.partner = this.helpersService.getPartnerData();
    this.countryData = this.helpersService.getCountryData();
    this.displayDateFormat = this.countryData.AngularDateFormat;
    this.displayDateTimeFormat =
      this.countryData.AngularDateFormat +
      ' ' +
      (this.countryData.code == 'US' ? 'hh:mm aa' : 'HH:mm');

    this.selectedPartnerIds = [this.partnerID];
    this.statusList = [];
    this.statusList = this.appConfig.getServiceStatusList().sort((a, b) => {
      if (a.index < b.index) return -1;
      else if (a.index > b.index) return 1;
      else return 0;
    });
    this.isAdmin = this.helpersService.isAdminUser();
    this.isWorkshopManager = this.helpersService.isWorkshopManagerUser();

    // Only add the status if it doesn't already exist in the list

    setTimeout(() => {
      const existingStatus = this.statusList.find(status => status.id === 'ItemHere');
      if (!existingStatus) {
        this.statusList.push({
          key: 'ItemHere',
          label: this.translate.instant('bikeshop.modal.update_job_card.job_card.bike_is_here'),
          apiPropertyName: 'Items_In_Workshop',
          id: 'ItemHere',
          index: 20,
        });
      }
    }, 10);
    


    this.cancellationreasons = this.appConfig.getCancellationReasons();
    this.generateColumnHeaders();
    this.loadPageDataForSelectedPartner();
    this.getLinkedEnabledPartners();

    console.log(this.helpersService.getProfileData());
  }

  generateColumnHeaders() {
    this.openColumns = [
      {
        header: this.translate.instant('general.headers.job_card'),
        field: 'JobCardNo',
        type: 'jobcardno',
      },
      {
        header: this.translate.instant('general.headers.cyclist'),
        field: 'CyclistDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('onboarding.phonenumber'),
        field: 'PhoneNumber',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.bike'),
        field: 'BikeDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.work_done'),
        field: 'TypeDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.technician'),
        field: 'TechnicianDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.scheduled'),
        field: 'DateCheckedIn',
        type: 'date',
      },
      {
        header: this.translate.instant('general.headers.original_date'),
        field: 'OriginalBookInDate',
        type: 'date',
      },
      {
        header: this.translate.instant(
          'general.headers.days_since_original_date',
        ),
        field: 'DaysSinceOriginalDate',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.status'),
        field: 'StatusDescription',
        type: 'status',
      },
    ];

    this.columns = [
      {
        header: this.translate.instant('general.headers.job_card'),
        field: 'JobCardNo',
        type: 'jobcardno',
      },
      {
        header: this.translate.instant('general.headers.cyclist'),
        field: 'CyclistDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('onboarding.phonenumber'),
        field: 'PhoneNumber',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.bike'),
        field: 'BikeDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.work_done'),
        field: 'TypeDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.technician'),
        field: 'TechnicianDescription',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.scheduled'),
        field: 'DateCheckedIn',
        type: 'date',
      },
      {
        header: this.translate.instant('general.headers.status'),
        field: 'StatusDescription',
        type: 'status',
      },
    ];
  }

  ngAfterViewInit() {
    // this.partnerService.getPartnerTechnicians(this.selectedPartner.partnerID).subscribe(result => {
    //   this.technicians = result;
    // });
  }

  loadPageDataForSelectedPartner() {
    for (let i = 0; i < this.statusList.length; i++) {
      this.statusList[i].metric = '';
    }

    this.getDashboardData();
    this.getRouteInfo();
    this.hasChecklistItems();
    this.getTechnicians();
  }

  getTechnicians() {
    this.partnerService
      .getPartnerTechniciansV2(this.selectedPartnerIds.join(','))
      .subscribe((result) => {
        console.log('getPartnerTechniciansV2');
        console.log(result);
        this.technicians = result;
      });
  }

  getDashboardData() {
    this.loading = true;
    this.dashboardService
      .getPartnerDashboardInfoV2(this.selectedPartnerIds.join(','))
      .subscribe((result) => {
        console.log('getPartnerDashboardInfoV2');
        console.log(result);
        console.log(this.statusList);
        this.dashboardInfo = result;
        for (let i = 0; i < this.statusList.length; i++) {
          this.statusList[i].metric = 0;
          for (let x = 0; x < this.dashboardInfo.length; x++) {
            this.statusList[i].metric +=
              this.dashboardInfo[x][this.statusList[i].apiPropertyName] || 0;
          }
          this.statusList[i].command = () => {
            this.menuSelected(i);
          };
          this.loading = false;
        }
      });
  }

  hasChecklistItems() {
    this.checklistService
      .hasChecklistItemsV2(this.partnerID, this.selectedPartnerIds.join(','))
      .subscribe(
        (res) => {
          console.log('hasChecklistItemsV2');
          console.log(res);

          let totalCount = 0;

          for (let x = 0; x < res.length; x++) {
            totalCount += res[x].checklistCount;
          }

          console.log(totalCount);

          this.helpersService.setChecklistCount(totalCount);
        },
        (err) => {
          this.helpersService.setChecklistCount(0);
        },
      );
  }

  getRouteInfo() {
    let routeId = this.route.snapshot.paramMap.get('id');
    if (routeId) {
      let index = this.statusList
        .map((status) => {
          return status.id.toString();
        })
        .indexOf(routeId);
      if (index > -1) {
        this.activeItem = this.statusList[index];
        this.menuSelected(index);
      } else {
        this.getFirstMenuItem();
      }
    } else {
      this.getFirstMenuItem();
    }
    this.routeData = routeId;
  }

  getFirstMenuItem() {
    this.activeItem = this.statusList[1]; //Skiping the real first item because thats pickups, and likely not important as the open jobs
    this.menuSelected(1);
  }

  buildColumns() {
    this.generateColumnHeaders();

    if (this.linkedPartners.length > 1) {
      const storeCol = {
        header: this.translate.instant('bikeshop.shop_profile.collections.store_name'),
        field: 'StoreName',
        type: 'string',
      };
      this.columns.unshift({ ...storeCol });
      this.openColumns.unshift({ ...storeCol });
    }

    // For Bike Ready (StatusID 45), add the "Days Since" column.
    // Powered by the V3 endpoint, which returns DaysSinceCurrentStatus
    // (days the job has been in its current status, from ServiceStatusHistory).
    const id = this.activeItem?.id;
    if (id === 45) {
      const daysSinceCol = {
        header: this.translate.instant('general.headers.days_since'),
        field: 'DaysSinceCurrentStatus',
        type: 'string',
      };
      const statusIdx = this.columns.findIndex((c) => c.field === 'StatusDescription');
      if (statusIdx > -1) {
        this.columns.splice(statusIdx, 0, daysSinceCol);
      } else {
        this.columns.push(daysSinceCol);
      }
    }
  }

  menuSelected(index) {
    console.log('Selecing index ' + index);
    this.jobCards = [];
    this.activeItem = this.statusList[index];
    this.buildColumns();
    this.router.navigateByUrl('/store/services/' + this.activeItem.id);
    this.routeData = this.activeItem.id;
    this.loadData(index);
    this.selectedFilter = 0;
    this.filters = [0];
    this.globalSelectValue = false;
  }

  openJobCard(jobcardID, partnerID) {

    if(this.partner.UseNewJobCard){
      this.newJobcardService.openManageJobCard(jobcardID, {
        onRefreshEvents: () => {
          this.getDashboardData();
          this.loadData(this.activeItem.index);
        }
      });
      return;
    }

    const modalRef = this.modalService.open(UpdateJobcardComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'jobcard-modal',
    });
    modalRef.componentInstance.jobcard = null;
    modalRef.componentInstance.jobcardID = jobcardID;
    modalRef.componentInstance.partnerID = partnerID;
    modalRef.result.then(
      (result) => { },
      (onrejected) => {
        this.getDashboardData();
        this.loadData(this.activeItem.index);
      },
    );
  }

  loadData(index) {
    this.loading = true;
    const statusId = this.statusList[index].id;
    const useV3 = statusId === 45;
    const request = useV3
      ? this.partnerService.getPartnerJobCardsMinimumV3(
          this.partnerID,
          String(statusId),
          this.selectedPartnerIds.join(','),
        )
      : this.partnerService.getPartnerJobCardsMinimumV2(
          this.partnerID,
          statusId,
          this.selectedPartnerIds.join(','),
        );

    request.subscribe(
      (result) => {
        console.log(useV3 ? 'getPartnerJobCardsMinimumV3' : 'getPartnerJobCardsMinimumV2');
        console.log(result);

        this.jobCards =
          this.statusList[index].id === 100
            ? result.sort((x, y) => {
              if (x.DateCheckedIn < y.DateCheckedIn) return 1;
              if (x.DateCheckedIn > y.DateCheckedIn) return -1;
              return 0;
            })
            : result;
        this.enrichJobCardsWithStoreName();
        this.loading = false;
        var items = result.map((x) => {
          return x.StatusID;
        });
        let uniqueItems = items
          .filter((v, i, a) => a.indexOf(v) === i)
          .sort((a, b) => {
            return a < b ? -1 : a > b ? 1 : 0;
          });
        this.filters = [0, ...uniqueItems];
        this.globalSelectValue = false;
        this.busyBulkActioning = false;
      },
      (err) => {
        console.error(useV3 ? 'getPartnerJobCardsMinimumV3 failed' : 'getPartnerJobCardsMinimumV2 failed', err);
        this.jobCards = [];
        this.filters = [0];
        this.loading = false;
        this.globalSelectValue = false;
        this.busyBulkActioning = false;
      },
    );
  }

  processAction(jobcard) {
    switch (this.activeItem.key) {
      case Statuses.SCHEDULED:
        this.actionBookIn(jobcard);
        break;
      case Statuses.BOOKEDIN:
        this.actionAssignToTechnician(jobcard);
        break;
      case Statuses.ASSIGNED:
        this.actionCommenceWork(jobcard);
        break;
      case Statuses.WORKINGON:
        this.actionCompleteJob(jobcard);
        break;
      case Statuses.COMPLETED:
        this.actionReadyForCollection(jobcard);
        break;
      case Statuses.READY:
        this.actionBikeCollected(jobcard);
        break;
    }
  }

  actionBookIn(jobcard) {
    jobcard.busy = true;
    this.serviceRequest.bookIn(jobcard.ID).subscribe((result) => {
      this.messageService.add({
        life: 5000,
        summary: this.translate.instant('bikeshop.services.action_complete'),
        detail: this.translate.instant('bikeshop.services.message_booked_in', {
          jobcard: jobcard.JobCardNo,
        }),
      });
      this.getDashboardData();
      this.loadData(this.activeItem.index);
    });
  }

  actionAssignToTechnician(jobcard) {
    jobcard.busy = true;
    const modalRef = this.modalService.open(SelectTechnicianModalComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.technicianList = this.technicians;
    modalRef.componentInstance.jobcard = jobcard;
    modalRef.result.then(
      (selectedTechnician) => {
        this.serviceRequest
          .assignToTechnician(jobcard.ID, selectedTechnician.ID)
          .subscribe((result) => {
            this.messageService.add({
              life: 5000,
              summary: this.translate.instant(
                'bikeshop.services.action_complete',
              ),
              detail: this.translate.instant(
                'bikeshop.services.message_assigned',
                {
                  jobcard: jobcard.JobCardNo,
                  technician:
                    selectedTechnician.Firstname +
                    ' ' +
                    selectedTechnician.Surname,
                },
              ),
            });
            this.getDashboardData();
            this.loadData(this.activeItem.index);
          });
      },
      (onrejected) => {
        jobcard.busy = false;
      },
    );
  }

  actionCommenceWork(jobcard) {
    jobcard.busy = true;
    this.serviceRequest.startWork(jobcard.ID).subscribe((result) => {
      this.messageService.add({
        life: 5000,
        summary: this.translate.instant('bikeshop.services.action_complete'),
        detail: this.translate.instant('bikeshop.services.message_commenced', {
          jobcard: jobcard.JobCardNo,
        }),
      });
      this.getDashboardData();
      this.loadData(this.activeItem.index);
    });
  }

  actionCompleteJob(jobcard) {
    jobcard.busy = true;
    this.serviceRequest.completeWork(jobcard.ID).subscribe((result) => {
      this.messageService.add({
        life: 5000,
        summary: this.translate.instant('bikeshop.services.action_complete'),
        detail: this.translate.instant('bikeshop.services.message_complete', {
          jobcard: jobcard.JobCardNo,
        }),
      });
      this.captureService(jobcard);
    });
  }

  actionReadyForCollection(jobcard) {
    jobcard.busy = true;
    this.captureService(jobcard);
  }

  actionBikeCollected(jobcard) {
    jobcard.busy = true;
    this.serviceRequest.collect(jobcard.ID).subscribe((result) => {
      this.messageService.add({
        life: 5000,
        summary: this.translate.instant('bikeshop.services.action_complete'),
        detail: this.translate.instant('bikeshop.services.message_collected', {
          jobcard: jobcard.JobCardNo,
        }),
      });
      this.getDashboardData();
      this.loadData(this.activeItem.index);
    });
  }

  captureService(jobcard) {
    /*this.serviceRequest.getServiceRequestData(jobcard.ID).subscribe(data => {
                  this.bikeService.getBike(jobcard.BikeID).subscribe(bike => {
                    this.bikeService.getActiveGear(jobcard.BikeID).subscribe(activeGear => {
                      this.serviceRequest.getGearReplacementFromPOS(jobcard.ID).subscribe(gearReplacement => {
                        this.invoiceService.getInvoice(jobcard.ID, false).subscribe(invoice => {
                          if(activeGear.length===0){
                            let service = data;
                            service.ServiceRequestID = jobcard.ID;
                            service.PartnerId = this.selectedPartner.partnerID;
                            service.ServicedGear = activeGear;
                            service.Invoice = invoice;
                            try{
                              this.bikeService.captureService(service).subscribe(captureData => {
                                this.serviceRequest.readyForCollection(jobcard.ID).subscribe(result=>{
                                  this.messageService.add({ life: 5000, summary: this.translate.instant('bikeshop.services.action_complete'), detail: 'Job card ' + jobcard.JobCardNo + ' is ready for collection.' });
                                  this.getDashboardData();
                                  this.loadData(this.activeItem.index);
                                });
                              });
                            }catch(err){
                              jobcard.busy = false;
                            }
                          }else{
                            //Take user to a screen to capture parts replaced etc.
                            jobcard.busy = false;
                          }
                        });
                      });
                    });
                  });
                });*/

    this.serviceRequest
      .getServiceRequestData(jobcard.ID)
      .subscribe((serviceData) => {
        this.bikeService.getBike(jobcard.BikeID).subscribe((bike) => {
          //1. Get Bikes Active Gear
          this.bikeService
            .getActiveGear(jobcard.BikeID)
            .subscribe((activeGear) => {
              //2. Get Gear Replacement List from POS
              this.serviceRequest
                .getGearReplacementFromPOS(jobcard.ID)
                .subscribe(
                  (gearReplacement) => {
                    //3. Get Invoice for Bike
                    this.invoiceService
                      .getInvoice(jobcard.ID, false)
                      .subscribe((invoice) => {
                        //4. Capture Service
                        let captureServiceData = {
                          BikeID: jobcard.BikeID,
                          PartnerID: jobcard.partnerID,
                          ServiceRequestID: serviceData.ID,
                          ServiceDate: serviceData.DateCheckedIn,
                          ServicedGear: gearReplacement,
                        };
                        this.bikeService
                          .captureService(captureServiceData)
                          .subscribe((service) => {
                            //5. Make bike ready for collection
                            this.serviceRequest
                              .readyForCollection(jobcard.ID)
                              .subscribe((jobcard) => {
                                this.messageService.add({
                                  life: 5000,
                                  summary: this.translate.instant(
                                    'bikeshop.services.action_complete',
                                  ),
                                  detail:
                                    'Job card ' +
                                    jobcard.JobCardNo +
                                    ' is ready for collection.',
                                });
                                this.getDashboardData();
                                this.loadData(this.activeItem.index);
                              });
                          });
                      });
                  },
                  (err) => {
                    //3. Get Invoice for Bike
                    this.invoiceService
                      .getInvoice(jobcard.ID, false)
                      .subscribe((invoice) => {
                        //4. Capture Service
                        let captureServiceData = {
                          BikeID: jobcard.BikeID,
                          PartnerID: jobcard.partnerID,
                          ServiceRequestID: serviceData.ID,
                          ServiceDate: serviceData.DateCheckedIn,
                          ServicedGear: null,
                        };
                        this.bikeService
                          .captureService(captureServiceData)
                          .subscribe((service) => {
                            //5. Make bike ready for collection
                            this.serviceRequest
                              .readyForCollection(jobcard.ID)
                              .subscribe((jobcard) => {
                                this.messageService.add({
                                  life: 5000,
                                  summary: this.translate.instant(
                                    'bikeshop.services.action_complete',
                                  ),
                                  detail:
                                    'Job card ' +
                                    jobcard.JobCardNo +
                                    ' is ready for collection.',
                                });
                                this.getDashboardData();
                                this.loadData(this.activeItem.index);
                              });
                          });
                      });
                  },
                );
            });
        });
      });
  }

  getStatusDescription(statusID, StatusDescription) {
    var status = this.appConfig
      .getStatusList()
      .filter((x) => {
        return x.id === statusID;
      })
      .pop();
    return statusID === 0 ? 'All' : status ? status.label : StatusDescription;
  }

  getStatusStyle(statusID) {
    var status = this.appConfig
      .getStatusList()
      .filter((x) => {
        return x.id === statusID;
      })
      .pop();
    return status ? status.styleClass : '';
  }

  public downloadFile() {
    var data = [];
    var header = this.routeData === 'open' ? this.openColumns : this.columns;
    data.push(header.map((x) => x.header.toString()));

    this.jobCards.forEach((element) => {
      var row = [];
      header.forEach((col) => {
        if (col.type === 'date') {
          row.push(
            moment(element[col.field]).format(
              this.countryData.MomentDateFormat + ' HH:mm',
            ),
          );
        } else {
          row.push(element[col.field]);
        }
      });
      data.push(row);
    });

    let csvData = this.convertToCSV(data);
    let file = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
    saveAs(file, 'Services.csv');
  }

  public convertToCSV(objArray: any, fields?) {
    let json2csvParser = new this.Json2csvParser({
      opts: fields,
      quote: '"',
      withBOM: true,
      header: false,
    });
    let csv = json2csvParser.parse(objArray);
    return csv;
  }

  globalSelected(event) {
    if (event.checked) {
      this.jobCards.forEach((x) => {
        x.selected =
          true && this.selectedFilter === 0
            ? 1 === 1
            : x.StatusID === this.selectedFilter;
      });
    } else {
      this.jobCards.forEach((x) => {
        x.selected = false;
      });
    }
  }

  isServicesSelected() {
    return (
      this.jobCards.filter((x) => {
        return x.selected === true;
      }).length > 0
    );
  }

  canBulkCancel() {
    return (
      this.jobCards.filter((x) => {
        return x.selected === true;
      }).length > 0 &&
      this.jobCards.filter((x) => {
        return x.selected === true && x.StatusID < 40;
      }).length ===
      this.jobCards.filter((x) => {
        return x.selected === true;
      }).length
    );
  }

  canBulkCollect() {
    return (
      this.jobCards.filter((x) => {
        return x.selected === true;
      }).length > 0 &&
      this.jobCards.filter((x) => {
        return x.selected === true && x.StatusID >= 40 && x.StatusID <= 45;
      }).length ===
      this.jobCards.filter((x) => {
        return x.selected === true;
      }).length
    );
  }

  canBulkComplete() {
    return (
      this.jobCards.filter((x) => {
        return x.selected === true;
      }).length > 0 &&
      this.jobCards.filter((x) => {
        return x.selected === true && x.StatusID < 40;
      }).length ===
      this.jobCards.filter((x) => {
        return x.selected === true;
      }).length
    );
  }

  canBulkDeliver() {
    return (
      this.jobCards.filter((x) => {
        return x.selected === true;
      }).length > 0 &&
      this.jobCards.filter((x) => {
        return x.selected === true && x.StatusID === 55;
      }).length ===
      this.jobCards.filter((x) => {
        return x.selected === true;
      }).length
    );
  }

  bulkCancel() {
    this.selectedCancellationReason = null;
    this.cancellationOtherReason = null;
    this.displayCancellation = true;
  }

  bulkCollect() {
    this.confirmationService.confirm({
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      message: this.translate.instant(
        'bikeshop.services.bulk_action.collect_jobs_confirmation',
        {
          count: this.jobCards.filter((x) => {
            return x.selected === true;
          }).length,
        },
      ),
      accept: () => {
        this.bulkUpdate(50);
      },
    });
  }

  bulkComplete() {
    this.confirmationService.confirm({
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      message: this.translate.instant(
        'bikeshop.services.bulk_action.complete_jobs_confirmation',
        {
          count: this.jobCards.filter((x) => {
            return x.selected === true;
          }).length,
        },
      ),
      accept: () => {
        this.bulkUpdate(45);
      },
    });
  }

  bulkDeliver() {
    this.confirmationService.confirm({
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      message: this.translate.instant(
        'bikeshop.services.bulk_action.deliver_jobs_confirmation',
        {
          count: this.jobCards.filter((x) => {
            return x.selected === true;
          }).length,
        },
      ),
      accept: () => {
        this.bulkUpdate(55);
      },
    });
  }

  beginJobCancellation() {
    if (this.selectedCancellationReason == CancellationReasons.OTHER) {
      this.cancellationOtherReason = '';
      this.showCancellationOtherReason = true;
    } else {
      this.cancellationOtherReason = '';
      this.showCancellationOtherReason = false;
    }
  }

  getSelectedCount() {
    return this.jobCards.filter((x) => {
      return x.selected === true;
    }).length;
  }

  bulkUpdate(statusID: number) {
    var data = {
      PartnerID: this.partnerID,
      StatusID: statusID,
      ServiceID: this.jobCards
        .filter((x) => {
          return x.selected;
        })
        .map((x) => {
          return x.ID;
        }),
      CancellationReason: null,
      CancellationOtherReason: null,
      isTesting: false,
    };

    if (statusID === 100) {
      var reason_ids = this.cancellationreasons.map((reason) => {
        return reason.value;
      });
      data.CancellationReason =
        this.cancellationreasons[
          reason_ids.indexOf(this.selectedCancellationReason)
        ].label;
      data.CancellationOtherReason = this.cancellationOtherReason;
      if (this.selectedCancellationReason === 1) {
        data.isTesting = true;
      }
    }

    this.displayCancellation = false;
    this.showCancellationOtherReason = false;
    this.busyBulkActioning = true;
    this.partnerService.bulkUpdateServiceStatuses(data).subscribe(
      (res) => {
        this.getDashboardData();
        this.loadData(this.statusList.indexOf(this.activeItem));
      },
      (err) => {
        this.busyBulkActioning = false;
      },
    );
  }

  getLinkedEnabledPartners() {
    if(!(this.isAdmin || this.isWorkshopManager)){
      return;
    }
    this.loadingPartners = true;
    this.collectionsV2Service
      .getAllLinkedPartners(this.partnerID)
      .subscribe(
        (res) => {
          console.log(res);
          this.linkedPartners = res;
          this.loadingPartners = false;

          this.selectedPartners.push(
            this.linkedPartners.find((y) => y.partnerID == this.partnerID),
          );
          if (this.linkedPartners.length > 1) {
            this.buildColumns();
          }
          this.enrichJobCardsWithStoreName();
        },
        (err) => {
          this.loadingPartners = false;
        },
      );
  }

  enrichJobCardsWithStoreName() {
    if (!Array.isArray(this.jobCards) || !Array.isArray(this.linkedPartners) || this.linkedPartners.length === 0) {
      return;
    }
    const nameByPartnerId = new Map<any, string>(
      this.linkedPartners.map((p: any) => [p.partnerID, p.partnerName]),
    );
    this.jobCards = this.jobCards.map((j: any) => ({
      ...j,
      StoreName:
        nameByPartnerId.get(j.PartnerID) ??
        nameByPartnerId.get(String(j.PartnerID)) ??
        nameByPartnerId.get(Number(j.PartnerID)) ??
        '',
    }));
  }

  updateFilter(partner) {
    this.selectedPartnerIds = partner.map((x) => {
      return x.partnerID;
    });
    this.selectedPartners = partner;
    console.log(this.selectedPartnerIds);
    console.log(this.selectedPartners);
    this.loadPageDataForSelectedPartner();
  }

  scheduleService() {

    if (this.partner.UseNewJobCard) {
      this.newJobcardService.scheduleWorkshopService({
        partnerId: this.partnerID,
        partnerData: this.partner,
        openJobCard: this.openJobCard.bind(this),
        onRefreshEvents: () => {
          this.loadData(this.activeItem.index);
          this.getDashboardData();
        }
      });
      return;
    }

    const modalRef = this.modalService.open(ScheduleServiceComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.partnerId = this.partnerID;

    modalRef.componentInstance.fromCalendar = false;
    modalRef.result.then(
      (result) => {
        this.getDashboardData();
        this.loadData(this.activeItem.index);
        if (result.openBooking && result.jobcard && result.jobcard.ID) {
          this.openJobCard(
            result.jobcard.ID,
            this.partner.OpenTabOnScheduleAndOpen,
          );
        }

        setTimeout(() => {
          if (
            this.partner &&
            this.partner.OpenPrintOnNewJob &&
            result.jobcard.StatusID > 15 &&
            result.jobcard.StatusID < 50
          ) {
            if (this.helpersService.getPrinterType() === 'A4') {
              var win = window.open(`/print/${result.jobcard.ID}`, '_blank');
              win.focus();
            } else {
              var win = window.open(
                `/print-till-slip/${result.jobcard.ID}`,
                '_blank',
              );
              win.focus();
            }
          }
        }, 1000);
      });
  }

  scheduleServiceUsingBarcode() {

    if (this.partner.UseNewJobCard) {
      const modalRef = this.modalService.open(WorkshopJobcardSearchSerialNumberComponent, {
        backdrop: true,
        backdropClass: 'jobcard-modal-popup-backdrop',
        windowClass: 'jobcard-modal-popup-window',
        size: 'lg'
      });

      modalRef.result.then(
        (result) => {
          console.log('Serial number search result:', result);
          // TODO: pass the looked-up item + customer through once the serial search returns them
          console.log(result);
          this.newJobcardService.scheduleWorkshopService({
            partnerId: this.partnerID,
            partnerData: this.partner,
            selectedItem: result.selectedItem,
            customer: result.customer,
            openJobCard: this.openJobCard.bind(this)
          });
        },
        (onrejected) => { },
      );
    }
  }
}
